<template>
	<div class="content">
		<div class="editInfor">
			<div>
				<div>
					<span class="red">*</span>手机号:
				</div>
				<div>
					<input type="text" v-model="CustomerPhone" @keypress="searchCustomers($event)" placeholder="扫描会员二维码"
						required="required" />
					<span class="err">{{$uil.checkPhone(CustomerPhone)?' ':'×'}}</span>
				</div>
				<div>
					<span class="red">*</span>会员姓名:
				</div>
				<div>
					<input type="text" readonly="readonly" v-model="CustomerName" required="required"
						placeholder="会员姓名" />
				</div>

				<div>
					<span class="red">*</span>会员分类:
				</div>
				<div>
					<select v-model="VipLevlID" disabled="disabled" readonly="readonly">
						<option v-for="(i,index) in vipLevl" :value="i.vipLevlID">{{i.Price +' '+i.vipTag}}</option>
					</select>
				</div>
				<div>
					<span class="red">*</span>开始时间:
				</div>
				<div>
					<input type="text" readonly="readonly" v-model="VipBeginDate" placeholder="格式:2021-01-01" />

				</div>

				<div>
					<span class="red">*</span>结束时间:
				</div>
				<div>
					<input type="text" v-model="VipEndDate" placeholder="格式:2021-01-01" />

				</div>
				<div>
					<span class="red"></span>账户押金:
				</div>
				<div>
					<span>{{Deposit| rmb}}</span>
				</div>

				<div>
					<span class="red">*</span>实收费:
				</div>
				<div>
					<input type="text" v-model="Disbursements" placeholder="正直收取,负值退还" :disabled="CustomerID==0" />

				</div>

				<div>
					<span class="red">{{Disbursements==0?"*":''}}</span>备注:
				</div>
				<div>
					<textarea v-model="remarks"></textarea>

				</div>

				<div>
					<span class="red">*</span>合计:
				</div>
				<div>
					<span>实收:{{Disbursements | rmb}}</span>
				</div>
				<div>
				</div>
				<div>
					<button class="button" :class="{'disabled':checkDate}" :disabled="checkDate"
						@click="editCustomer">{{ CustomerID==0?'确定':'确定'}}</button>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<button class="button" @click="clear()">取消</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'customersDeposit',
		data() {
			return {
				timeType: '0',
				vipLevl: '',
				CustomerID: 0,
				CustomerPhone: '',
				CustomerName: '',
				VipBeginDate: '',
				VipEndDate: '',
				VipLevlID: 1,
				Disbursements: '',
				Deposit: 0,
				VipLevlIDIndex: 0,
				OperatorID: this.$store.state.user.UserID,
				clear: {},
				remarks: ''
			};
		},
		created() {
			this.clear = function() {
				this.CustomerID = 0;
				this.CustomerName = "";
				this.remarks = "";
				this.Disbursements = 0;
				this.Deposit = 0;
				this.CustomerPhone = "";
				this.VipEndDate = "";
				this.VipEndDate = "";
			};
			this.$request.request({
				url: 'Customer/getVipLevl',
				data: {},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.vipLevl = res.vipLevl;
				}
			});

		},
		methods: {
			editCustomer() {
				this.$request.request({
					url: 'Customer/customerDeposit',
					data: {
						CustomerID: this.CustomerID,
						Disbursements: this.Disbursements,
						remarks: this.remarks,
						OperatorID: this.OperatorID,
					},
					method: 'post'
				}).then(res => {
					this.$uil.showMessage({
						text: res.message
					});
      this.Deposit = res.customer.Deposit;
	  this.Disbursements=0;
				});
			},
			searchCustomers(e) {
				if (e.keyCode == 13 && this.CustomerPhone.length >=11) {
					this.$request.request({
						url: 'Customer/getCustomerByCustomerCode',
						data: {
							searchText: this.CustomerPhone
						},
						method: 'post'
					}).then(res => {
						if (res.result) {
							this.CustomerPhone = res.customer.CustomerPhone;
							this.CustomerName = res.customer.CustomerName;
							this.Deposit = res.customer.Deposit;
							this.CustomerID = res.customer.CustomerID;
							this.VipBeginDate = res.customer.VipBeginDate;
							this.VipEndDate = res.customer.VipEndDate;
							this.VipLevlID = res.customer.VipLevlID;
						}
					});
				}
			}
		},
		computed: {
			checkDate() {
				if(isNaN((this.Disbursements))) return true;
				
				if (this.CustomerName == "") return true;
				if (this.Disbursements == 0 && this.remarks == '') return true;
				if (this.VipBeginDate == '' || this.VipEndDate == "") return true;
				let begin = new Date(this.VipBeginDate.replace(/-/g, '/'));
				let end = new Date(this.VipEndDate.replace(/-/g, '/'));
				if (begin >= end)
					return true;
				else
					return false;
			}
		},
		filters: {
			rmb(v) {
				return v + '¥';
			}
		},
		watch: {
			Disbursements: function(n, o) {
				console.log(this.Deposit*1+n*1);
				if ( this.Deposit*1 + n*1 < 0) this.Disbursements = '';


			}
		}
	}
</script>

<style>
</style>
